<template>
  <section>
    <vue-highcharts type="chart" :options="options" class="custom-zonedist" />
  </section>
</template>
<script>
import { mapGetters } from 'vuex'
import VueHighcharts from 'vue3-highcharts'
export default {
  name: 'session-zonedist-chart',
  components: {
    VueHighcharts,
  },
  computed: {
    ...mapGetters('usercardio', ['memberSession']),
    program() {
      let _data = {
        MinutesBelowZone: 0,
        MinutesInZone: 0,
        MinutesAboveZone: 0,
      }
      if (this.memberSession) {
        _data = this.memberSession.program[0]
      }
      console.log('Zone Dist: Program', _data)
      return _data
    },
    session() {
      let _data = {
        BelowZoneTime: 0,
        InZoneTime: 0,
        AboveZoneTime: 0,
      }
      if (this.memberSession) {
        _data = this.memberSession.session
      }
      console.log('Zone Dist: Session', _data)
      return _data
    },
    plotdata() {
      let _data = []
      if (this.memberSession) {
        _data = {
          Categories: ['Below Zone', 'In Zone', 'Above Zone'],
          Goals: [
            {
              x: 0,
              y: parseFloat(this.program.MinutesBelowZone),
              name: 'Below Zone',
              color: '#CDCDCD',
            },
            {
              x: 1,
              y: parseFloat(this.program.MinutesInZone),
              name: 'In Zone',
              color: '#CBE1F4',
            },
            {
              x: 2,
              y: parseFloat(this.program.MinutesAboveZone),
              name: 'Above Zone',
              color: '#FFD2A5',
            },
          ],
          Zones: [
            {
              x: 0,
              y: parseFloat(this.session.BelowZoneTime),
              name: 'Below Zone',
              color: '#959595',
            },
            {
              x: 1,
              y: parseFloat(this.session.InZoneTime),
              name: 'In Zone',
              color: '#004C72',
            },
            {
              x: 2,
              y: parseFloat(this.session.AboveZoneTime),
              name: 'Above Zone',
              color: '#F87712',
            },
          ],
        }
      }
      console.log('Zone Dist: Data', _data)
      return _data
    },
    options() {
      let _options = {}
      if (this.memberSession) {
        _options = {
          chart: {
            backgroundColor: null,
            borderWidth: 0,
            type: 'column',
            style: {
              overflow: 'visible',
            },
            spacing: [5, 10, 5, 10],
            marginTop: 20,
            animation: false,
          },
          title: {
            text: '',
          },
          credits: {
            enabled: false,
          },
          xAxis: {
            categories: this.plotdata.Categories,
          },
          yAxis: [
            {
              min: 0,
              title: {
                text: 'minutes',
              },
            },
          ],
          legend: {
            enabled: false,
          },
          tooltip: {
            shared: true,
          },
          plotOptions: {
            column: {
              grouping: false,
              shadow: false,
              borderWidth: 0,
            },
          },
          series: [
            {
              name: 'Goal',
              data: this.plotdata.Goals,
              pointPadding: 0.3,
              pointPlacement: -0.2,
              animation: false,
            },
            {
              name: 'Actual',
              data: this.plotdata.Zones,
              pointPadding: 0.4,
              pointPlacement: -0.2,
              animation: false,
            },
          ],
        }
      }
      console.log('Zone Dist: Options', _options)
      return _options
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-zonedist {
  width: 450px;
  height: 200px;
  margin: 0 auto;
}
</style>
